import { Framework } from '@/framework';
import { type ContextMenuPlugin, type GetCustomContextMenuFn } from '@/plugins/context-menu';

interface IContextMenu {
    registerContextMenu: (customContextMenuFn: GetCustomContextMenuFn) => void;
    unregisterContextMenu: () => void;
}

export interface TableEditingSession {
    id: number;
    layerId: string;
    exit: () => boolean | Promise<boolean>;
}

export class TableLayerEdit extends Framework implements IContextMenu {
    private session: TableEditingSession | null = null;

    private tryGetContextMenu() {
        const contextMenu = this.framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin');
        if (!contextMenu) {
            throw new Error('ContextMenuPlugin is not found');
        }
        return contextMenu;
    }

    constructor(identity: string) {
        super(identity);
        this.exit = this.exit.bind(this);
        this.getSession = this.getSession.bind(this);
        this.registerSession = this.registerSession.bind(this);
        this.registerContextMenu = this.registerContextMenu.bind(this);
        this.unregisterContextMenu = this.unregisterContextMenu.bind(this);
    }

    /** 获取当前单元格编辑会话。 */
    getSession() {
        return this.session;
    }

    /** 注册当前单元格编辑会话，并返回只清理该会话的函数。 */
    registerSession(session: TableEditingSession) {
        this.session = session;
        return () => {
            if (this.session === session) this.session = null;
        };
    }

    /** 提交并退出当前单元格编辑会话。 */
    async exit() {
        const session = this.session;
        if (!session) return true;

        const didExit = await session.exit();
        if (!didExit) return false;
        if (this.session === session) this.session = null;
        return this.session?.layerId !== session.layerId;
    }

    registerContextMenu(customContextMenuFn: GetCustomContextMenuFn) {
        this.tryGetContextMenu().registerContextMenu(customContextMenuFn);
    }

    unregisterContextMenu() {
        this.tryGetContextMenu().unregisterContextMenu();
    }
}
